/** @format */

import { useEffect, useState } from 'react';
import './Loading.css';

const Loading = () => {
  let rawuserInfo = {};
  const [userInfo, setUserInfo] = useState([]);

  const checkLoading = (userInfomation) => {
    if (
      userInfomation == '' ||
      userInfomation == null ||
      userInfomation == undefined ||
      userInfomation == 0 ||
      userInfomation == NaN
    ) {
    } else {
      console.log(userInfomation);
      sessionStorage.setItem('UserData', JSON.stringify(userInfomation));
      window.open('https://milestone-1.firebaseapp.com/Home', '_self');
    }
  };

  const Params = () => {
    const current = decodeURI(window.location.href);
    const search = current.split('?')[1];
    const params = new URLSearchParams(search);
    const keywords = params.get('code');
    console.log(keywords);

    return keywords;
  };

  let userToken = Params();
  const fetPath = async () => {
    // const OPEN_API_DOMAIN = 'http://localhost:8080/request?code=';
    const OPEN_API_DOMAIN = process.env.REACT_APP_API_ADDRESS + '/request?code=';
    const token = userToken;
    const rawReasponse = await fetch(`${OPEN_API_DOMAIN}${token}`);
    const jsonResponse = await rawReasponse.json();
    console.log(jsonResponse);
    return jsonResponse;
  };
  useEffect(() => {
    rawuserInfo = fetPath();
    rawuserInfo.then((value) => setUserInfo(value));
  }, []);

  console.log(userInfo);

  setTimeout(() => checkLoading(userInfo), 1000);
  return (
    <div>
      <div className="loadingLogo">
        <img
          src={process.env.PUBLIC_URL + '/assets/Loading-Spinner-1s-200px.gif'}
        />
      </div>
      <div className="loadingTitle">Loading...</div>
      <div className="loadingText">
        <div>사용자의 데이터에 따라 최대 2~3분가량 소요될 수 있습니다.</div>
      </div>
    </div>
  );
};

export default Loading;
